// sentry.ts
import * as Sentry from '@sentry/vue'
import type { App } from 'vue'
import router from '../router'

const SentryPlugin = {
	install(app: App) {
		if (!import.meta.env.VITE_SENTRY_DSN) return

		const apiUrl = import.meta.env.VITE_PUBLIC_API_URL
		const apiHostRegex = new RegExp('^' + apiUrl.replace(/\./g, '\\.'))

		Sentry.init({
			app,
			dsn: import.meta.env.VITE_SENTRY_DSN,
			sendDefaultPii: true,
			integrations: [Sentry.browserTracingIntegration({ router })],
			tracesSampleRate: 1.0,
			tracePropagationTargets: ['localhost', apiHostRegex],
			environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || 'development'
		})
	}
}

export default SentryPlugin
